<template>
  <div v-if="proyectoValido === true">

    <div class="evento-container">
      <!-- Encabezado Unificado -->
      <div class="evento-header" @click="toggleDetalles">
        <div class="header-left">
          <h2 class="evento-title">
            <font-awesome-icon icon="fas fa-chart-line" class="me-2" />
            {{ evento_cultivo.nombre_evento }}
          </h2>
          <div v-if="evento.evento_finalizado" class="evento-finalizado">
            <span class="mensaje-finalizado">
              <font-awesome-icon icon="fas fa-exclamation-circle" class="me-1" />
              <strong>Evento Finalizado:</strong> Este evento es de solo lectura y se considera un Reporte Histórico de Trazabilidad.
            </span>
          </div>
          <div class="header-preliminar">
            <div class="preliminar-panel">
              <template v-if="evento.evento_finalizado">
                <div class="preliminar-item">
                  <strong>Inicio:</strong> {{ evento.fecha_inicio_formateada }}
                </div>
                <div class="preliminar-item">
                  <strong>Fin Evento:</strong> {{ evento.fecha_fin_evento_formateada }}
                </div>
              </template>
              <template v-else>
                <div class="preliminar-item">
                  <strong>Inicio:</strong> {{ evento.fecha_inicio_formateada }}
                </div>
                <div class="preliminar-item">
                  <strong>Semana Actual:</strong> {{ semanaActual }}
                </div>
                <div class="preliminar-item">
                  <strong>{{ diasFaltantesTexto }}:</strong> {{ diasFaltantes }}
                </div>

                <div class="progress mt-2" style="height: 20px; width: 15%;">
                  <div class="progress-bar" :class="barraClase" role="progressbar"
                    :style="{ width: progresoEvento + '%' }" :aria-valuenow="progresoEvento" aria-valuemin="0"
                    aria-valuemax="100">
                    {{ progresoEvento }}%
                  </div>
                </div>


              </template>
            </div>
            <div class="toggle-icon">
              <font-awesome-icon :icon="mostrarDetalles ? 'fas fa-angle-up' : 'fas fa-angle-down'" />
            </div>
          </div>
        </div>

        <!-- Barra de acciones sin navegación -->
        <div class="header-right" @click.stop>
          <nav class="navbar navbar-expand-lg navbar-light">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <a class="nav-link" href="#" @click.prevent="irAListarTareas">
                  <font-awesome-icon icon="fas fa-list" class="me-1" />
                  Ver Tareas
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#" @click.prevent="irAAltaTarea"
                  :class="{ disabled: evento.evento_finalizado }">
                  <font-awesome-icon icon="fas fa-plus" class="me-1" />
                  Tarea
                </a>
              </li>


              <li class="nav-item"
                v-if="evento_cultivo.nombre_evento !== 'Secado' && evento_cultivo.nombre_evento !== 'Curado'">
                <a class="nav-link" href="#" @click.prevent="irAMoverPlantaEvento"
                  :class="{ disabled: evento.evento_finalizado }">
                  <font-awesome-icon :icon="['fas', 'angles-right']" class="me-1" />
                  Asignar Plantas a este Evento
                </a>
              </li>
              <li class="nav-item"
                v-if="(evento_cultivo.nombre_evento === 'Cosecha' || evento_cultivo.nombre_evento === 'Secado' || evento_cultivo.nombre_evento === 'Curado')">
                <a class="nav-link" href="#" @click.prevent="irAMoverBiomasaEvento"
                  :class="{ disabled: evento.evento_finalizado }">
                  <font-awesome-icon icon="fas fa-seedling" class="me-1" />
                  Biomasa
                </a>
              </li>


            </ul>
          </nav>
        </div>
      </div>

      <!-- Panel Extra (detalles expandibles) -->
      <transition name="fade">
        <div v-if="mostrarDetalles" class="evento-info-extra">
          <div class="info-row">
            <div class="info-item">
              <p><strong>Fin:</strong> {{ evento.fecha_fin_formateada }}</p>
            </div>
            <div class="info-item">
              <p>
                <strong>Costo Planificado:</strong>
                <span class="text-success">{{ costoEstimadoEvento }} $</span>
              </p>
            </div>
          </div>
        </div>
      </transition>

      <!-- Contenido de la sección activa -->
      <transition name="fade" mode="out-in">
        <component :is="currentSectionComponent" :proyecto_id="proyecto_id" :proyecto_evento_id="proyecto_evento_id"
          @biomasaGuardada="handleCosechaRealizada" @migrar="handleMigrar" @tareaCreada="handleTareaCreada" @cancelar="handleCancelar"
          @plantasAdministradas="handlePlantasAdministradas" @cosechaRealizada="handleCosechaRealizada"
          :key="`${section}-${proyecto_evento_id}`" />
      </transition>
    </div>
  </div>

  <div v-else-if="proyectoValido === false" class="alert alert-warning text-center mt-4">
    <font-awesome-icon icon="exclamation-triangle" class="me-2" />
    {{ mensajeError }}
  </div>

  <div v-if="cargando" class="text-center mt-4">
    <font-awesome-icon icon="spinner" spin class="me-2" />
    Cargando evento...
  </div>
</template>

<script>
import axios from '@/axios';
import moment from 'moment';

// Importa aquí los componentes que antes estaban en rutas hijas
import ListarTareas from '@/components/Tarea/listarTareas/listar-tareas.vue';
import AltaTarea from '@/components/Tarea/altaTarea/alta-tarea.vue';
import EventoPlantasView from '@/views/PlantaEvento/EventoPlantasView.vue';
import ListarBiomasa from '@/components/Biomasa/biomasaList.vue';
//import MoverBiomasaEvento from '@/components/BiomasaEvento/MoverBiomasaEvento.vue';
import EventoBiomasaView from '@/views/BiomasaEvento/EventoBiomasaView.vue';
export default {
  name: 'EventoDetalle',
  props: {
    proyecto_id: {
      type: Number,
      required: true
    },
    proyecto_evento_id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      evento: {},
      evento_cultivo: {},
      semanaActual: 0,
      diasFaltantes: 0,
      costoEstimadoEvento: 0,
      mostrarDetalles: false,
      // Sección activa: 'listarTareas' por defecto
      section: 'listarTareas',
      proyectoValido: null, // ← se inicializa como null para mostrar loading opcional
      mensajeError: '',
      progresoEvento: 0,
      diasFaltantesTexto: '',
      cargando: true,




    };
  },
  computed: {
    // Devuelve el componente apropiado según la sección activa
    currentSectionComponent() {
      switch (this.section) {
        case 'altaTarea':
          return AltaTarea;
        case 'moverPlantas':
          return EventoPlantasView;
        case 'listarBiomasa':
          return ListarBiomasa;
        case 'moverBiomasaEvento':
          return EventoBiomasaView;
        case 'listarTareas':
        default:
          return ListarTareas;
      }
    },
    barraClase() {
      if (this.progresoEvento < 50) return 'bg-success';
      if (this.progresoEvento < 85) return 'bg-warning';
      return 'bg-danger';
    }

  },
  watch: {
    proyecto_evento_id: {
      immediate: true,
      handler() {
        // Restablecer el estado al cambiar de proyecto
        this.proyectoValido = null;
        this.mensajeError = '';
        // Siempre mostrar listado de tareas al cambiar de evento
        this.section = 'listarTareas';
        // Validar el proyecto al cambiar de evento
        this.validarProyecto();
      }
    }
  },
  created() {
    // Validar el proyecto al crear el componente
    this.validarProyecto();
  },
  mounted() {
    // Cargar el evento al montar el componente
    this.cargarEvento();
  },
  methods: {
    // Carga los datos del evento
    async cargarEvento() {
      this.cargando = true;
      try {

        const { data } = await axios.get(
          `/api/proyectoEvento/${this.proyecto_evento_id}`
        );
        this.evento = data;
        this.$store.commit('setEventoActual', data);
        this.evento_cultivo = data.evento_cultivo;

        this.evento.fecha_inicio_formateada = this.formatearFecha(
          data.fecha_inicio
        );
        this.evento.fecha_fin_formateada = this.formatearFecha(
          data.fecha_fin
        );
        this.evento.fecha_fin_evento_formateada = this.formatearFecha(
          data.fecha_fin_evento
        );
        this.semanaActual = this.calcularSemanaActual(this.evento.fecha_inicio);
        const dias = this.calcularDiasFaltantes(this.evento.fecha_fin);
        this.diasFaltantes = dias.valor;
        this.diasFaltantesTexto = dias.texto;

        this.costoEstimadoEvento = data.costo_planificado_usd || 0;

        this.progresoEvento = this.calcularProgresoEvento(data.fecha_inicio, data.fecha_fin);

      } catch (err) {
        console.error('Error al cargar el evento:', err);
      } finally {
        this.cargando = false;
      }
    },
    calcularProgresoEvento(fechaInicio, fechaFin) {
      const inicio = moment(fechaInicio);
      const fin = moment(fechaFin);
      const hoy = moment();

      if (hoy.isBefore(inicio)) return 0;
      if (hoy.isAfter(fin)) return 100;

      const totalDuracion = fin.diff(inicio, 'days');
      const transcurridos = hoy.diff(inicio, 'days');

      return Math.round((transcurridos / totalDuracion) * 100);
    },
    async validarProyecto() {
      try {

        const response = await axios.get(`/api/validarProyectoConLotesConPlantas/${this.proyecto_id}`);

        
        if (response.data.valido === false) {
          this.proyectoValido = false;
          this.mensajeError = response.data.error;
          return;
        }


        this.proyectoValido = true;
        this.cargarEvento(); // solo carga si el proyecto es válido
      } catch (error) {
        this.proyectoValido = false;
        this.mensajeError = error.response?.data?.error || 'Error al validar el proyecto';

      }
    },
    formatearFecha(fecha) {
      return new Intl.DateTimeFormat('es-ES', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      }).format(new Date(fecha));
    },
    calcularSemanaActual(fechaInicio) {
      const inicio = moment(fechaInicio);
      const dias = moment().diff(inicio, 'days');
      return Math.ceil(dias / 7) + 1;
    },
    calcularDiasFaltantes(fechaFin) {
      const hoy = moment();
      const fin = moment(fechaFin);
      const diferencia = fin.diff(hoy, 'days');

      if (diferencia >= 0) {
        return { texto: 'Días Faltantes', valor: diferencia };
      } else {
        return { texto: 'Días Pasados', valor: Math.abs(diferencia) };
      }
    },
    toggleDetalles() {
      this.mostrarDetalles = !this.mostrarDetalles;
    },

    // Métodos para cambiar sección en lugar de push/router-view
    irAListarTareas() {
      this.section = 'listarTareas';
    },
    irAAltaTarea() {
      if (!this.evento.evento_finalizado) {
        this.section = 'altaTarea';
      }
    },
    irAMoverPlantaEvento() {
      if (!this.evento.evento_finalizado) {
        this.section = 'moverPlantas';
      }
    },
    irAMoverBiomasaEvento() {
      if (!this.evento.evento_finalizado) {
        this.section = 'moverBiomasaEvento';
      }
    },
    irACosechar() {
      if (this.evento_cultivo.nombre_evento === 'Cosecha') {
        // this.section = 'cosechar';
      }
    },

    irAListarBiomasa() {
      this.section = 'listarBiomasa';
    },

    // Handlers para reenviar eventos desde las sub‑vistas al padre
    handleTareaCreada(nuevaTarea) {
      this.$emit('tareaCreada', nuevaTarea);
      this.irAListarTareas();
    },
    handlePlantasAdministradas(payload) {
      this.$emit('plantasAdministradas', payload);
      this.irAListarTareas();
    },
    handleCosechaRealizada(resultado) {
      this.$emit('cosechaRealizada', resultado);
      this.irAListarTareas();
    },
    handleMigrar(payload) {
      this.$emit('migrar', payload);
      this.irAListarTareas();
    },
    handleCancelar() {
      this.irAListarTareas();
    }
  }
};
</script>



<style scoped>
.evento-container {
  background-color: #ffffff;
  border-radius: 15px;
  padding: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin: 0.5rem auto;
  max-width: 90%;
}

.evento-header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background-color: #f7f9fc;
  border: 1px solid #d1d9e6;
  border-radius: 15px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.header-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.evento-title {
  font-size: 2rem;
  font-weight: bold;
  color: #2c3e50;
  margin: 0;
  text-align: center;
}

.evento-finalizado {
  text-align: center;
}

.mensaje-finalizado {
  display: inline-block;
  padding: 0.5rem 1rem;
  border: 1px solid #e74c3c;
  background-color: #fce4e4;
  color: #e74c3c;
  border-radius: 8px;
  font-size: 1.1rem;
}

.header-right {
  margin-top: 1rem;
}

.navbar {
  background: transparent;
  padding: 0;
}

.navbar-nav .nav-link {
  font-size: 1.1rem;
  padding: 0.6rem 1.2rem;
  transition: background-color 0.3s ease;
}

.navbar-nav .nav-link:hover {
  background-color: #e3e9f0;
  border-radius: 5px;
}

.navbar-nav .nav-link.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.header-preliminar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem;
  background-color: #f0f4f8;
  border-radius: 10px;
  font-size: 1.1rem;
  color: #34495e;
}

.preliminar-panel {
  display: flex;
  gap: 1.5rem;
  flex: 1;
  justify-content: flex-start;
}

.preliminar-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.toggle-icon {
  font-size: 1.5rem;
  color: var(--app-primary);
}

.evento-info-extra {
  background-color: #f8f9fa;
  border: 1px solid #e5e5e5;
  border-radius: 15px;
  padding: 1rem;
  margin-top: 0.75rem;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.info-item {
  flex: 1 1 33%;
  min-width: 160px;
  padding: 0.6rem;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.info-item p {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 500;
  color: #2c3e50;
}

@media (max-width: 768px) {
  .evento-header {
    gap: 0.5rem;
    padding: 0.5rem;
  }

  .evento-title {
    font-size: 1.5rem;
  }

  .header-right {
    width: 100%;
    margin-top: 1rem;
  }

  .preliminar-panel {
    flex-direction: column;
    gap: 0.5rem;
  }

  .info-row {
    flex-direction: column;
  }

  .info-item {
    flex: 1 1 100%;
    padding: 0.5rem;
  }

  .navbar-nav .nav-link {
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }

  .mensaje-finalizado {
    font-size: 1rem;
    padding: 0.4rem 0.8rem;
  }
}
</style>
